export default __webpack_public_path__ + "static/trio-on-floor-af7c22732f90ee2ec8eea3d30107078d.jpeg";